import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { cognitoUserPool, logout } from "../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, Divider, IconButton } from "@mui/material"
import Grid from "@mui/material/Grid2"
import CloseIcon from '@mui/icons-material/Close';
import ReactPasswordChecklist from "react-password-checklist"

export default function ChangePasswordModal({
    open,
    closeModal
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [oldPassword, setOldPassword] = React.useState("")
    const [newPassword, setNewPassword] = React.useState("")
    const [newPassword2, setNewPassword2] = React.useState("")
    const [isValid, setIsValid] = React.useState(false)

    React.useEffect(() => {
        setOldPassword("")
        setNewPassword("")
        setNewPassword2("")
        setIsValid(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const update_password = () => {
        if (newPassword === newPassword2) {
            const user = cognitoUserPool.getCurrentUser()
            if (user != null) {
                user.getSession((err, session) => {
                    if (err) {
                        logout()
                        return;
                    }
                    user.setSignInUserSession(session)
                    user.changePassword(oldPassword, newPassword, function (err, result) {
                        if (err) {
                            enqueueSnackbar(err.message || JSON.stringify(err), { variant: 'error' })
                            return;
                        }
                        enqueueSnackbar("Password Updated Successfully", { variant: 'success' })
                        closeModal(true)
                    });
                })
            } else {
                logout();
                return
            }
        }
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='sm'
                fullWidth
            >
                <DialogTitle>
                    {"Change Password"}
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                            pt: '13px'
                        }}
                    >
                        <TextField
                            label="Old Password"
                            type={'password'}
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            required
                        />
                        <Divider />
                        <TextField
                            label="New Password"
                            type={'password'}
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                        <TextField
                            label="Confirm New Password"
                            type={'password'}
                            value={newPassword2}
                            onChange={(e) => setNewPassword2(e.target.value)}
                            required
                        />
                        <ReactPasswordChecklist
                            rules={["minLength", "specialChar", "number", "capital", "lowercase", "match"]}
                            minLength={8}
                            value={newPassword}
                            valueAgain={newPassword2}
                            onChange={(isValid) => { setIsValid(isValid) }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 10px 10px 30px" }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={update_password} disabled={!isValid || oldPassword.length === 0}>
                                Update Password
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
